import Timeline from './Timeline';

export default Timeline;

export {
	Timeline,
};
